// src/component/datatable2/models/SortCycle.ts

export interface SortState {
    sortField?: string | null;
    sortOrder?: number | null;
}

/**
 * Sort button of a column header: none → ascending → descending → none.
 * Sorting another column starts it ascending. Every change goes back to
 * the first page.
 */
export class SortCycle {
    static next<T extends SortState>(criteria: T, fieldName: string): T & { first: number } {
        if (criteria.sortField !== fieldName) {
            return { ...criteria, sortField: fieldName, sortOrder: 1, first: 0 };
        }

        if (criteria.sortOrder === 1) {
            return { ...criteria, sortField: fieldName, sortOrder: -1, first: 0 };
        }

        return { ...criteria, sortField: null, sortOrder: null, first: 0 };
    }
}
